import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'api';

export interface UsageRecord {
  id: number;
  date: string;
  activity: string;
  credit: number;
  balance: number;
  reference: string;
}

export interface UsageBreakdownResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: UsageRecord[];
}

export type ActivityFilter = 'cv_analysis' | 'generate_questions' | 'refine_question' | 'assessment_scoring' | 'cv_relevance' | 'strengths_gaps' | 'comparison' | 'share_report' | 'analytics' | 'collaborative_session' | 'jd_upload' | 'jd_generate';

export interface UsageBreakdownParams {
  activity?: ActivityFilter;
  search?: string;
  page?: number;
}

/**
 * Hook to fetch usage breakdown data
 */
export const useFetchUsageBreakdown = (params?: UsageBreakdownParams) => {
  return useQuery({
    queryKey: ['usageBreakdown', params],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      if (params?.activity) searchParams.append('activity', params.activity);
      if (params?.search) searchParams.append('search', params.search);
      if (params?.page) searchParams.append('page', params.page.toString());

      const queryString = searchParams.toString();
      const url = `/billing/dashboard/usage-breakdown/${queryString ? `?${queryString}` : ''}`;

      const response = await apiClient.get<UsageBreakdownResponse>(url);
      return response.data;
    },
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};
